export default [
  {
    path: '/zrater',
    // name: "insurance.home",
    component: () => import('@/views/zrater/LayoutPage.vue'),
    meta: {
      title: 'ZRater Portal',
    },
    redirect: { name: 'home', force: true },
    children: [
      {
        path: '',
        name: 'zrater.state',
        redirect: { name: 'home' },
        // component: () => import('@/views/zrater/StartPage.vue'),
        meta: {
          title: 'Select State',
        },
      },
      // {
      //   path: ":state",
      //   name: "zrater.form",
      //   component: () => import("@/views/zrater/SchemaStateForm.vue"),
      //   meta: {
      //     title: "Form Schema",
      //   },
      // },
      {
        path: ':state',
        name: 'zrater.form.customer',
        component: () => import('@/views/zrater/customer/PrimaryInfo.vue'),
        meta: {
          title: 'Form Schema',
          step: 1,
        },
      },
      {
        path: ':state/vehicles',
        name: 'zrater.form.vehicles',
        component: () => import('@/views/zrater/vehicle/VehiclesForm.vue'),
        meta: {
          title: 'Form Schema',
          step: 2,
        },
      },
      {
        path: ':state/drivers',
        name: 'zrater.form.drivers',
        component: () => import('@/views/zrater/driver/DriversForm.vue'),
        meta: {
          title: 'Form Schema',
          step: 3,
        },
      },
      {
        path: ':state/quote/results',
        name: 'zrater.form.additional',
        component: () => import('@/views/zrater/quote/AdditionalParams.vue'),
        meta: {
          title: 'AdditionalParams',
          step: 4,
        },
      },
      {
        path: ':state/quote/final',
        name: 'zrater.form.final',
        component: () => import('@/views/zrater/quote/FinalPage.vue'),
        meta: {
          title: 'Final Quote',
          step: 4,
        },
      },
    ],
  },
];
